const Validations = {
  message: {
    presence: true,
  },
};

export default Validations;
